import React from "react";
import { track } from "../../../../analytics";
import "./BusinessInternetCard.scss";

const BusinessInternetCard = ({ img, title, text, show }) => {
  return (
    <div className="businessInternetCard_block">
      <div className="businessInternetCard_img">
        <img src={img} alt="" />
      </div>
      <h3 className="businessInternetCard_speed">{title}</h3>
      <p className="businessInternetCard_text">{text}</p>
      <button
        type="button"
        className="businessInternetCard_btn"
        onClick={() => {
          track("cta_click", { place: "business_speed", label: String(title || "") });
          show(true);
        }}
      >
        Оставить заявку
      </button>
    </div>
  );
};

export default BusinessInternetCard;
